/**
 * 文本框组件 JavaScript
 * 处理动态图标显示、label浮动、清除功能等
 */


/**
 * XSS 检测函数
 * 检测输入内容是否包含可执行的脚本代码
 */
function detectXSS(input) {
  if (!input || typeof input !== 'string') {
    return false;
  }
  
  // XSS 攻击模式检测
  const xssPatterns = [
    // Script 标签
    /<script[\s\S]*?>[\s\S]*?<\/script>/gi,
    /<script[\s\S]*?>/gi,
    
    // JavaScript 协议
    /javascript:/gi,
    /jscript:/gi,
    /vbscript:/gi,
    /data:text\/html/gi,
    /data:image\/svg\+xml/gi,
    
    // 事件处理器
    /on\w+\s*=/gi,  // onclick=, onerror=, onload= 等
    /on\w+\s*:/gi,  // onclick:, onerror: 等
    
    // 危险函数调用
    /\beval\s*\(/gi,
    /\bsetTimeout\s*\(/gi,
    /\bsetInterval\s*\(/gi,
    /\bFunction\s*\(/gi,
    /\bexecScript\s*\(/gi,
    
    // 危险标签
    /<iframe[\s\S]*?>/gi,
    /<object[\s\S]*?>/gi,
    /<embed[\s\S]*?>/gi,
    /<link[\s\S]*?>/gi,
    /<meta[\s\S]*?>/gi,
    /<style[\s\S]*?>[\s\S]*?<\/style>/gi,
    
    // 编码的脚本（常见编码方式）
    /&#x3c;script/gi,  // HTML 实体编码
    /&#60;script/gi,
    /%3cscript/gi,     // URL 编码
    /%3Cscript/gi,
    
    // Base64 编码的 data URI（可能包含脚本）
    /data:[\w\/\+]+;base64,[\w\+\/=]+/gi,
    
    // 表达式注入（IE）
    /expression\s*\(/gi,
    
    // 其他危险模式
    /<img[\s\S]*?src[\s\S]*?=/gi,
    /<svg[\s\S]*?onload/gi,
    /<body[\s\S]*?onload/gi,
  ];

  // 检测是否匹配任何 XSS 模式
  for (let pattern of xssPatterns) {
    if (pattern.test(input)) {
      return true;
    }
  }

  return false;
}

/**
 * SQL 注入检测函数
 * 检测输入内容是否包含 SQL 注入攻击模式
 * 注意：前端检测只能作为第一道防线，真正的防护必须在后端进行
 * 
 * 检测策略：
 * 1. 检测明显的 SQL 注入模式（如 UNION SELECT、OR 1=1 等）
 * 2. 检测 SQL 注释符与关键字的组合
 * 3. 检测编码的 SQL 注入尝试
 * 4. 避免误报：不单独检测 SQL 关键字，只检测可疑的组合模式
 */
function detectSQLInjection(input) {
  if (!input || typeof input !== 'string') {
    return false;
  }
  
  // 转换为小写进行检测（不区分大小写）
  const lowerInput = input.toLowerCase();
  
  // SQL 注入攻击模式检测（更精确的模式，减少误报）
  const sqlPatterns = [
    // UNION SELECT 注入（最常见的 SQL 注入模式）
    /\bunion\s+[\w\s,]*\bselect\b/gi,
    
    // 布尔盲注：OR/AND 1=1, OR/AND 'a'='a' 等
    /\b(or|and)\s+['"]?\d+['"]?\s*=\s*['"]?\d+['"]?/gi,
    /\b(or|and)\s+['"][\w]+['"]\s*=\s*['"][\w]+['"]/gi,
    /\b(or|and)\s+['"]?1['"]?\s*=\s*['"]?1['"]?/gi,
    
    // SQL 注释符与关键字的组合（可疑模式）
    /(--|\#|\/\*)[\s]*\b(select|insert|update|delete|drop|create|alter|exec|execute|union)\b/gi,
    
    // 堆叠查询：分号后跟 SQL 语句
    /;[\s]*\b(select|insert|update|delete|drop|create|alter|exec|execute|union)\b/gi,
    
    // 时间盲注：SLEEP、WAITFOR、BENCHMARK 函数
    /\b(sleep|waitfor|benchmark)\s*\(/gi,
    
    // 文件操作注入：LOAD_FILE、INTO OUTFILE 等
    /\b(load_file|into\s+outfile|into\s+dumpfile)\s*\(/gi,
    
    // 单引号转义尝试：' OR '1'='1, '; DROP TABLE, '-- 等
    /'[\s]*(or|and|;|--|\/\*)/gi,
    
    // 双引号转义尝试
    /"[\s]*(or|and|;|--|\/\*)/gi,
    
    // 编码的 SQL 注入（URL 编码）
    /(%27|%22)[\s]*(%4f%52|%41%4e%44|%3b|%2d%2d)/gi,  // ' OR, " AND, ;, --
    
    // 十六进制编码的 SQL 关键字
    /0x[0-9a-f]*(53454c454354|494e53455254|555044415445|44454c455445)/gi,  // SELECT, INSERT, UPDATE, DELETE
    
    // 双重编码尝试
    /%25[0-9a-f]{2}/gi,  // %25 是 % 的编码，表示双重编码
  ];

  // 检测是否匹配任何 SQL 注入模式
  for (let pattern of sqlPatterns) {
    if (pattern.test(lowerInput)) {
      return true;
    }
  }

  return false;
}

function getTextInputMessage(key, fallback) {
  if (window.getFrontendMessage && typeof window.getFrontendMessage === 'function') {
    return window.getFrontendMessage(key, fallback);
  }

  return fallback;
}

/**
 * 清理 XSS 内容
 * 移除或转义危险字符
 */
function sanitizeInput(input) {
  if (!input || typeof input !== 'string') {
    return input;
  }

  // 移除所有 HTML 标签
  let sanitized = input.replace(/<[^>]*>/g, '');
  
  // 移除 JavaScript 协议
  sanitized = sanitized.replace(/javascript:/gi, '');
  sanitized = sanitized.replace(/jscript:/gi, '');
  sanitized = sanitized.replace(/vbscript:/gi, '');
  
  // 移除事件处理器
  sanitized = sanitized.replace(/on\w+\s*=/gi, '');
  
  return sanitized;
}

/**
 * 获取输入框的逻辑类型（当实际 type 被改写为 text 时使用）
 */
function getLogicalFieldType(field) {
  if (!field) {
    return '';
  }
  
  const intendedType =
    field.getAttribute('data-original-type') ||
    field.getAttribute('data-intended-type') ||
    (field.dataset ? field.dataset.intendedType : '') ||
    field.getAttribute('type') ||
    field.type ||
    '';
  
  return intendedType.toLowerCase();
}

document.addEventListener('DOMContentLoaded', function() {
    // 初始化所有文本框组件
  initTextInputs();
  
  // 延迟再次检查，确保所有动态内容都已加载
  setTimeout(() => {
    initTextInputs();
  }, 100);
});

// 添加全局函数，可以在需要时手动触发
window.reinitializeTextInputs = function() {
  initTextInputs();
};

function initTextInputs() {
  // 页面现在可能同时存在多个 responsive/grid layout。
  // 这里直接全页扫描文本框组件，再用 data-initialized 防重复绑定，
  // 避免只初始化到第一个 layout，导致后续 section 的 label 浮动失效。
  const textInputs = document.querySelectorAll('[data-component="text-input"]');

  textInputs.forEach((input, index) => {
    // 防重复初始化：同一组件只绑定一次事件
    if (input.getAttribute('data-initialized') === 'true') {
      return;
    }
    input.setAttribute('data-initialized', 'true');

    const field = input.querySelector('.component-text-input__field');
    const label = input.querySelector('.component-text-input__label');
    const clearBtn = input.querySelector('.component-text-input__clear-btn');
    const errorIcon = input.querySelector('.component-text-input__error-icon');
    const showDynamicIcons = input.hasAttribute('data-show-dynamic-icons') || input.getAttribute('data-show-dynamic-icons') === 'true';
    
    
    if (!field) return;
    
    // 保存输入框的原始类型（逻辑类型）
    const intendedTypeForField = field.getAttribute('data-intended-type') || field.type;
    if (!field.getAttribute('data-original-type')) {
      field.setAttribute('data-original-type', intendedTypeForField);
    }
    
    // 初始化状态
    // 初始化时移除error类，确保不会显示error状态
    field.classList.remove('component-text-input__field--error');
    field.classList.remove('component-text-input__field--valid');
    field.dataset.isImeComposing = 'false';
    
    // 移除组件级别的错误状态类
    const inputContainer = field.closest('.component-text-input');
    if (inputContainer) {
      inputContainer.classList.remove('component-text-input--invalid');
      inputContainer.classList.remove('component-text-input--valid');
      inputContainer.classList.remove('component-text-input--validating');
    }
    
    // 确保标签初始状态正确
    if (label) {
      // 检测是否为iOS Safari
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
      
      // 检查输入框是否有初始值
      const hasInitialValue = field.value.length > 0;
      
      if (hasInitialValue) {
        // 如果有初始值，确保标签浮动
        label.classList.add('is-float');
      } else if (isIOS && isSafari) {
        // 如果没有初始值且是iOS Safari，强制重置标签状态
        label.classList.remove('is-float');
        label.style.transform = 'translateY(-50%)';
        label.style.webkitTransform = 'translateY(-50%)';
      }
    }
    
    // 初始化时保存安全值
    if (field.value) {
      if (!detectXSS(field.value)) {
        field.setAttribute('data-safe-value', field.value);
      } else {
        // 如果初始值包含 XSS，清理它
        field.value = sanitizeInput(field.value);
        field.setAttribute('data-safe-value', field.value);
      }
    } else {
      field.setAttribute('data-safe-value', '');
    }
    
    updateInputState(field, label, clearBtn, errorIcon, showDynamicIcons);
    scheduleAutofillStateSync(field, label, clearBtn, errorIcon, showDynamicIcons);
    
      // 限制数字输入框不能输入点号
      if (field.getAttribute('data-intended-type') === 'number') {
        field.addEventListener('keydown', function(e) {
          if (e.key === '.' || e.key === 'Decimal') {
            e.preventDefault();
          }
        });
        
        // 防止粘贴带小数点的数字
        field.addEventListener('paste', function(e) {
          const pastedData = (e.clipboardData || window.clipboardData).getData('text');
          if (pastedData && pastedData.includes('.')) {
            e.preventDefault();
          }
        });
      }
      
      // 阻止所有输入框输入空格 (如果 data-allow-space="false")
    // 阻止空格键输入
    field.addEventListener('keydown', function(e) {
      const inputContainer = field.closest('.component-text-input');
      const allowSpace = inputContainer ? inputContainer.getAttribute('data-allow-space') !== 'false' : true;
      
      const isImeComposing = e.isComposing || e.keyCode === 229 || field.dataset.isImeComposing === 'true';

      // 避免误伤 IME 输入过程中的空格/选词
      if (!allowSpace && (e.key === ' ' || e.keyCode === 32) && !isImeComposing) {
        e.preventDefault();
        return false;
      }
    });
    
    // 阻止粘贴时包含空格，并处理 maxlength
    field.addEventListener('paste', function(e) {
      const inputContainer = field.closest('.component-text-input');
      const allowSpace = inputContainer ? inputContainer.getAttribute('data-allow-space') !== 'false' : true;
      const pastedText = (e.clipboardData || window.clipboardData).getData('text');
      const maxLength = field.getAttribute('maxlength');
      const fieldType = getLogicalFieldType(field);
      
      let processedText = pastedText;
      let needPreventDefault = false;
      
      // 如果不允许空格：移除空格
      if (!allowSpace && /\s/.test(pastedText)) {
        needPreventDefault = true;
        processedText = pastedText.replace(/\s/g, '');
      }
      
      // 电话号码输入框：只保留数字
      if (fieldType === 'tel') {
        needPreventDefault = true;
        processedText = pastedText.replace(/\D/g, '');
      }
      
      // 处理 maxlength：截断超出部分
      if (maxLength) {
        const start = this.selectionStart;
        const end = this.selectionEnd;
        const currentValue = this.value;
        const beforeText = currentValue.substring(0, start);
        const afterText = currentValue.substring(end);
        const newValue = beforeText + processedText + afterText;
        
        if (newValue.length > parseInt(maxLength)) {
          needPreventDefault = true;
          const availableLength = parseInt(maxLength) - beforeText.length - afterText.length;
          if (availableLength > 0) {
            processedText = processedText.substring(0, availableLength);
          } else {
            processedText = '';
          }
        }
      }
      
      // 如果需要阻止默认行为，手动设置值
      if (needPreventDefault) {
        e.preventDefault();
        const start = this.selectionStart;
        const end = this.selectionEnd;
        const currentValue = this.value;
        this.value = currentValue.substring(0, start) + processedText + currentValue.substring(end);
        const newCursorPos = start + processedText.length;
        this.setSelectionRange(newCursorPos, newCursorPos);
        // 触发 input 事件
        this.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
    
    field.addEventListener('compositionstart', function() {
      field.dataset.isImeComposing = 'true';
    });

    // 输入事件
    field.addEventListener('input', function(e) {
      // 解决中文输入法吞字符问题：如果正在进行 IME 输入（如拼音），不进行处理
      if (e.isComposing || field.dataset.isImeComposing === 'true') return;

      const inputContainer = field.closest('.component-text-input');
      const allowSpace = inputContainer ? inputContainer.getAttribute('data-allow-space') !== 'false' : true;
      
      // 如果不允许空格：移除空格（作为备用方案，防止其他方式输入空格）
      if (!allowSpace) {
        const originalValue = field.value;
        const newValue = originalValue.replace(/\s/g, '');
        if (originalValue !== newValue) {
          const start = field.selectionStart;
          const end = field.selectionEnd;
          field.value = newValue;
          // 调整光标位置
          const lengthDiff = originalValue.length - newValue.length;
          const newStart = Math.max(0, start - lengthDiff);
          const newEnd = Math.max(0, end - lengthDiff);
          field.setSelectionRange(newStart, newEnd);
        }
      }
      
      // 电话号码输入框：只允许数字
      if (getLogicalFieldType(field) === 'tel') {
        const originalValue = field.value;
        const newValue = originalValue.replace(/\D/g, '');
        if (originalValue !== newValue) {
          const start = field.selectionStart;
          const end = field.selectionEnd;
          field.value = newValue;
          // 调整光标位置
          const lengthDiff = originalValue.length - newValue.length;
          const newStart = Math.max(0, start - lengthDiff);
          const newEnd = Math.max(0, end - lengthDiff);
          field.setSelectionRange(newStart, newEnd);
        }
      }
      
      const currentValue = field.value;
      
      // 保存安全的值（用于失焦时检测）
      field.setAttribute('data-safe-value', currentValue);

  const preservePriorityError = isPriorityErrorActive(field);
  const inputElement = field.closest('.component-text-input');
  
  if (!preservePriorityError) {
    // 输入时移除error类，确保不会显示error状态
    field.classList.remove('component-text-input__field--error');
    field.classList.remove('component-text-input__field--valid');
    
    // 移除组件级别的错误状态类
    if (inputElement) {
      inputElement.classList.remove('component-text-input--invalid');
      inputElement.classList.remove('component-text-input--valid');
      inputElement.classList.remove('component-text-input--validating');
    }
    
    // 调用全局错误隐藏函数
    if (window.hideTextInputError) {
      window.hideTextInputError(field);
    }
    
    // 清除错误信息显示
    const errorElement = inputElement ? inputElement.querySelector('.component-text-input__error') : null;
    if (errorElement) {
      errorElement.style.display = 'none';
    }
    
    // 移除 aria-invalid 属性
    field.removeAttribute('aria-invalid');
  } else if (inputElement) {
    // 维持错误状态展示
    const errorElement = inputElement.querySelector('.component-text-input__error');
    if (errorElement) {
      errorElement.style.display = 'flex';
    }
    inputElement.classList.add('component-text-input--error');
  }
      
      updateInputState(field, label, clearBtn, errorIcon, showDynamicIcons);
    });
    
    // 监听 IME 输入结束事件，确保在中文输入完成后执行 input 逻辑
    field.addEventListener('compositionend', function(e) {
      field.dataset.isImeComposing = 'false';

      // 触发 input 事件，让 input 监听器处理最终的值（如去除空格等）
      // 使用 setTimeout 确保在 current call stack 结束后执行
      setTimeout(() => {
        field.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
      }, 0);
    });
    
    // 聚焦事件
    field.addEventListener('focus', function() {
      const preservePriorityError = isPriorityErrorActive(field);
      const inputElement = field.closest('.component-text-input');
      
      if (!preservePriorityError) {
        // 清除所有错误状态和错误提示
        clearInputError(field);
        
        // 聚焦时移除error类，确保不会显示error状态
        field.classList.remove('component-text-input__field--error');
        field.classList.remove('component-text-input__field--valid');
        
        // 移除组件级别的错误状态类
        if (inputElement) {
          inputElement.classList.remove('component-text-input--error');
          inputElement.classList.remove('component-text-input--invalid');
          inputElement.classList.remove('component-text-input--valid');
          inputElement.classList.remove('component-text-input--validating');
        }
        
        // 调用全局错误隐藏函数
        if (window.hideTextInputError) {
          window.hideTextInputError(field);
        }
        
        // 如果label和type都是password，隐藏text-input-nowtimestamp-error
        if (field.type === 'password' && label && label.textContent.trim().toLowerCase() === 'password') {
          if (inputElement) {
            const errorElement = inputElement.querySelector('.text-input-nowtimestamp-error');
            if (errorElement) {
              errorElement.style.display = 'none';
            }
          }
        }
      } else if (inputElement) {
        const errorElement = inputElement.querySelector('.component-text-input__error');
        if (errorElement) {
    errorElement.style.display = 'flex';
        }
        inputElement.classList.add('component-text-input--error');
      }
      
      handleFocus(field, label, clearBtn, errorIcon, showDynamicIcons);
    });
    
    // 失焦事件
    field.addEventListener('blur', function(e) {
      // 检查是否点击了清除按钮或密码切换按钮
      const relatedTarget = e.relatedTarget;
      const isClickingButton = relatedTarget && (
        relatedTarget.closest('.component-text-input__clear-btn') ||
        relatedTarget.closest('.component-text-input__password-toggle') ||
        relatedTarget.closest('.component-text-input__password-icon')
      );
      
      if (isClickingButton) {
        return; // 不处理失焦逻辑
      }
      
      handleBlur(field, label, clearBtn, errorIcon, showDynamicIcons);
    });
    
    // 清除按钮点击事件
    if (clearBtn) {
      // 添加 mousedown 事件确保按钮获得焦点
      clearBtn.addEventListener('mousedown', function(e) {
        e.preventDefault();
        clearBtn.focus();
      });
      
      clearBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // 直接清除输入框值
        field.value = '';
        
        // 移除错误状态
        field.classList.remove('component-text-input__field--error');
        
        // 清除错误信息 - 使用新的公共函数
        if (window.hideTextInputError) {
          window.hideTextInputError(field);
        } else if (window.TextInputComponent) {
          // 降级方案
          window.TextInputComponent.clearError(field);
        }
        
        // 立即聚焦到输入框（在更新状态之前）
        field.focus();
        
        // 延迟更新状态，确保聚焦状态正确
        setTimeout(() => {
          updateInputState(field, label, clearBtn, errorIcon, showDynamicIcons);
        }, 0);

        // 触发自定义清除事件，方便外部（如 phone-with-dialcode）联动处理
        const clearEvent = new CustomEvent('input:clear', {
          detail: { field }
        });
        field.dispatchEvent(clearEvent);
      });
    }
    
    // 密码切换按钮事件
    const inputContainerForToggle = field.closest('.component-text-input');
    const passwordToggle = inputContainerForToggle && inputContainerForToggle.querySelector('.component-text-input__password-toggle');
    
    if (passwordToggle && field.getAttribute('data-original-type') === 'password') {
      // 添加 mousedown 事件确保按钮获得焦点
      passwordToggle.addEventListener('mousedown', function(e) {
        e.preventDefault();
        passwordToggle.focus();
      });
      
      passwordToggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const eyeIcon = passwordToggle.querySelector('.component-text-input__password-icon--eye');
        const eyeSlashIcon = passwordToggle.querySelector('.component-text-input__password-icon--eye-slash');
        
        // 保存当前光标位置
        const start = field.selectionStart;
        const end = field.selectionEnd;
        
        // 根据当前类型决定切换方向
        const isCurrentlyPassword = field.type === 'password';
        
        if (isCurrentlyPassword) {
          // 当前是密码模式：显示密码（变成text类型）
          field.type = 'text';
          if (eyeIcon) {
            eyeIcon.style.display = 'block';
          }
          if (eyeSlashIcon) {
            eyeSlashIcon.style.display = 'none';
          }
        } else {
          // 当前是文本模式：隐藏密码（变成password类型）
          field.type = 'password';
          if (eyeIcon) {
            eyeIcon.style.display = 'none';
          }
          if (eyeSlashIcon) {
            eyeSlashIcon.style.display = 'block';
          }
        }
        
        // 立即恢复光标位置并保持聚焦
        field.focus();
        field.setSelectionRange(start, end);
        
        // 强制更新状态，确保按钮保持可见
        setTimeout(() => {
          const hasValue = field.value.length > 0;
          const isFocused = field === document.activeElement;
          updatePasswordToggleVisibility(field, hasValue, isFocused);
        }, 10);
      });
    }

    // 添加软键盘确认键处理
    field.addEventListener('keydown', function(e) {
      const isImeComposing = e.isComposing || e.keyCode === 229 || field.dataset.isImeComposing === 'true';

      // 邮箱输入框不允许输入空格
      // 防止在 IME 输入过程中（某些输入法可能使用空格选词）被拦截
      if (getLogicalFieldType(field) === 'email' && (e.key === ' ' || e.keyCode === 32) && !isImeComposing) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      
      if (e.key === 'Enter') {
        // IME 组合输入时，Enter 用于确认候选词，不能在这里触发 blur，
        // 否则浏览器可能会把同一段候选文本提交两次。
        if (isImeComposing) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        
        // 触发失焦（失焦时会进行 XSS 检测）
        this.blur();
        
        // 触发自定义事件，让页面可以监听
        const enterEvent = new CustomEvent('textInputEnter', {
          detail: {
            input: this,
            value: this.value,
            component: input
          }
        });
        input.dispatchEvent(enterEvent);
      }
    });
    
    // 电脑端自动聚焦功能（仅桌面端，不包括平板和手机）
    const shouldAutofocusDesktop = input.hasAttribute('data-autofocus-desktop') || 
                                    input.getAttribute('data-autofocus-desktop') === 'true';
    // 只在真正的桌面端（>1068px）触发自动聚焦，平板（735-1068px）和手机（<=734px）都不触发
    const isDesktop = window.innerWidth > 1068;
    if (shouldAutofocusDesktop && isDesktop) {
      // 延迟聚焦，确保页面完全加载
      setTimeout(() => {
        field.focus();
      }, 100);
    }
  });
}

function allowsErrorOnFocus(field) {
  return !!(field && field.dataset && field.dataset.allowErrorOnFocus === 'true');
}

/**
 * 浏览器自动填充不一定触发 input 事件，延迟同步一次 UI 状态。
 */
function scheduleAutofillStateSync(field, label, clearBtn, errorIcon, showDynamicIcons) {
  const sync = function () {
    if (!field || !field.isConnected) return;
    updateInputState(field, label, clearBtn, errorIcon, showDynamicIcons);
  };

  // 覆盖常见 autofill 注入时机：首帧后、短延迟、较长延迟。
  requestAnimationFrame(sync);
  setTimeout(sync, 120);
  setTimeout(sync, 600);
}

function isPriorityErrorActive(field) {
  return !!(allowsErrorOnFocus(field) && field.dataset.errorPriorityActive === 'true');
}

/**
 * 更新输入框状态
 */
function updateInputState(field, label, clearBtn, errorIcon, showDynamicIcons) {
  const value = field.value.trim();
  const hasValue = value.length > 0;
  const isFocused = field === document.activeElement;
  const forceErrorWhileFocused = isPriorityErrorActive(field);
  
  // 输入和聚焦时不应该有error状态，只有在失焦时才检查error
  const baseHasError = field.classList.contains('component-text-input__field--error');
  const hasError = forceErrorWhileFocused ? baseHasError : (!isFocused && baseHasError);
  
  // 更新输入框的has-value类
  if (hasValue) {
    field.classList.add('component-text-input__field--has-value');
  } else {
    field.classList.remove('component-text-input__field--has-value');
  }

  field.classList.toggle('component-text-input__field--truncate', hasValue && !isFocused);
  
  // 更新 label 状态
  updateLabelState(field, label, hasValue, isFocused);
  
  // 更新动态图标
  if (showDynamicIcons) {
    updateDynamicIcons(clearBtn, errorIcon, hasValue, hasError, isFocused, forceErrorWhileFocused);
  }
  
  // 更新密码切换按钮显示状态
  updatePasswordToggleVisibility(field, hasValue, isFocused);
}

/**
 * 更新 label 状态
 */
function updateLabelState(field, label, hasValue, isFocused) {
  if (!label) return;
  
  // 检测是否为iOS Safari
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
  
  // 如果有值，label总是浮动（无论是否聚焦）
  if (hasValue) {
    label.classList.add('is-float');
  } else if (isFocused) {
    // 如果聚焦且无值，label也浮动（因为正在输入）
    label.classList.add('is-float');
  } else {
    // 如果无值且未聚焦，label回到中间
    label.classList.remove('is-float');
    
    // iOS Safari 特殊处理：强制重置transform
    if (isIOS && isSafari) {
      // 使用 setTimeout 确保DOM更新完成
      setTimeout(() => {
        if (!label.classList.contains('is-float')) {
          label.style.transform = 'translateY(-50%)';
          label.style.webkitTransform = 'translateY(-50%)';
        }
      }, 0);
    }
  }
}

/**
 * 更新密码切换按钮显示状态
 */
function updatePasswordToggleVisibility(field, hasValue, isFocused) {
  if (!field) return;
  
  // 检查是否为密码输入框 - 根据初始类型判断
  const isPasswordField = field.getAttribute('data-original-type') === 'password';
  
  if (!isPasswordField) {
    return;
  }
  
  const input = field.closest('.component-text-input');
  if (!input) return;
  
  const passwordToggle = input.querySelector('.component-text-input__password-toggle');
  const errorIcon = input.querySelector('.component-text-input__error-icon');
  if (!passwordToggle) {
    return;
  }
  
  // 根据UI Kit的要求：
  // 1. 输入密码前无icon：无值且未聚焦时隐藏
  // 2. 失焦后icon隐藏：失焦时隐藏
  // 3. 有值且聚焦时显示
  // 注意：输入时不应该有error状态，所以不检查hasError
  const shouldShow = hasValue && isFocused;
  
  if (shouldShow) {
    passwordToggle.style.display = 'flex';
    // 隐藏错误图标，因为密码切换按钮和错误图标在同一位置
    if (errorIcon) {
      errorIcon.style.display = 'none';
    }
  } else {
    passwordToggle.style.display = 'none';
    // 确保错误图标也被隐藏
    if (errorIcon) {
      errorIcon.style.display = 'none';
    }
  }
}

/**
 * 更新动态图标
 */
function updateDynamicIcons(clearBtn, errorIcon, hasValue, hasError, isFocused, forceErrorWhileFocused = false) {
  // 检查是否为密码输入框 - 根据初始类型判断
  const input = clearBtn && clearBtn.closest('.component-text-input');
  const field = input && input.querySelector('.component-text-input__field');
  const isPasswordField = field && field.getAttribute('data-original-type') === 'password';
  
  // 失焦且有错误：显示错误图标，隐藏所有按钮
  const shouldShowErrorIcon = hasError && (!isFocused || forceErrorWhileFocused);
  if (shouldShowErrorIcon) {
    if (errorIcon) {
      errorIcon.style.display = 'flex';
    }
    if (clearBtn) {
      clearBtn.style.display = 'none';
    }
    // 隐藏密码切换按钮，让错误图标显示
    const passwordToggle = input && input.querySelector('.component-text-input__password-toggle');
    if (passwordToggle) {
      passwordToggle.style.display = 'none';
    }
    return;
  }
  
  // 聚焦且有值：显示相应按钮，隐藏错误图标
  if (isFocused && hasValue) {
    // 聚焦时隐藏错误图标，恢复primary主题
    if (errorIcon) {
      errorIcon.style.display = 'none';
    }
    
    if (isPasswordField) {
      // 密码字段：隐藏清除按钮，密码切换按钮由updatePasswordToggleVisibility控制
      if (clearBtn) {
        clearBtn.style.display = 'none';
      }
    } else {
      // 非密码字段：显示清除按钮
      if (clearBtn) {
        clearBtn.style.display = 'flex';
      }
    }
    return;
  }
  
  // 其他情况：隐藏所有动态图标
  if (clearBtn) {
    clearBtn.style.display = 'none';
  }
  if (errorIcon) {
    errorIcon.style.display = 'none';
  }
  const passwordToggle = input && input.querySelector('.component-text-input__password-toggle');
  if (passwordToggle) {
    passwordToggle.style.display = 'none';
  }
}

/**
 * 处理聚焦事件
 */
function handleFocus(field, label, clearBtn, errorIcon, showDynamicIcons) {
  const value = field.value.trim();
  const hasValue = value.length > 0;
  const forceErrorWhileFocused = isPriorityErrorActive(field);
  
  // 聚焦时不传递错误状态，恢复primary主题，除非指定强制显示
  const hasError = forceErrorWhileFocused && field.classList.contains('component-text-input__field--error');
  
  // 聚焦时，如果有值则浮动，如果无值也浮动（因为正在输入）
  updateLabelState(field, label, hasValue, true);
  
  // 更新动态图标
  if (showDynamicIcons) {
    updateDynamicIcons(clearBtn, errorIcon, hasValue, hasError, true, forceErrorWhileFocused);
  }
  
  // 更新密码切换按钮显示状态
  updatePasswordToggleVisibility(field, hasValue, true);
  
  // 确保聚焦状态正确
  field.classList.add('component-text-input__field--focused');
  field.classList.remove('component-text-input__field--truncate');
}

/**
 * 处理失焦事件
 */
function handleBlur(field, label, clearBtn, errorIcon, showDynamicIcons) {
  let value = field.value.trim();
  const hasValue = value.length > 0;
  const hasError = field.classList.contains('component-text-input__field--error');
  
  // XSS 检测：如果检测到脚本，显示错误（不清空内容）- 与 password 组件保持一致
  if (hasValue && detectXSS(value)) {
    // 显示 XSS 错误
    setInputError(field, getTextInputMessage('invalidInputDetected', 'Invalid input detected'));
    
    // 更新状态（保持 hasValue，不清空内容）
    updateLabelState(field, label, hasValue, false);
    updatePasswordToggleVisibility(field, hasValue, false);
    field.classList.remove('component-text-input__field--focused');
    
    // 更新动态图标
    if (showDynamicIcons) {
      updateDynamicIcons(clearBtn, errorIcon, hasValue, true, false);
    }

    field.classList.toggle('component-text-input__field--truncate', hasValue);
    
    return;
  }
  
  // SQL 注入检测：如果检测到 SQL 注入模式，显示错误（不清空内容）
  if (hasValue && detectSQLInjection(value)) {
    // 显示 SQL 注入错误
    setInputError(field, getTextInputMessage('invalidInputDetected', 'Invalid input detected'));
    
    // 更新状态（保持 hasValue，不清空内容）
    updateLabelState(field, label, hasValue, false);
    updatePasswordToggleVisibility(field, hasValue, false);
    field.classList.remove('component-text-input__field--focused');
    
    // 更新动态图标
    if (showDynamicIcons) {
      updateDynamicIcons(clearBtn, errorIcon, hasValue, true, false);
    }

    field.classList.toggle('component-text-input__field--truncate', hasValue);
    
    return;
  }
  
  // 失焦时，如果没有值，label回到中间
  updateLabelState(field, label, hasValue, false);
  
  // 更新密码切换按钮显示状态
  updatePasswordToggleVisibility(field, hasValue, false);
  
  // 移除聚焦状态
  field.classList.remove('component-text-input__field--focused');
  field.classList.toggle('component-text-input__field--truncate', hasValue);
  
  // 如果有值，进行基本验证
  if (hasValue) {
    const fieldType = getLogicalFieldType(field);
    let isValid = true;
    let errorMessage = '';
    // 邮箱验证
    if (fieldType === 'email') {
      // 检查最小长度
      const minLength = field.getAttribute('minlength');
      if (minLength && value.length < parseInt(minLength)) {
        isValid = false;
        errorMessage = getTextInputMessage('emailInvalid', 'Email format incorrect, please try again.');
      }
      // 检测中文字符
      if (isValid) {
        const hasChineseChar = /[\u4e00-\u9fa5]/.test(value);
        if (hasChineseChar) {
          isValid = false;
          errorMessage = getTextInputMessage('emailInvalid', 'Email format incorrect, please try again.');
        }
      }
      // 检查邮箱格式 - 使用 validator.js + tldts
      if (isValid) {
        let isValidEmail = false;
        
        // 第一步：使用 validator.js 进行基础格式校验
        if (window.validator && typeof window.validator.isEmail === 'function') {
          // 使用 validator.js 进行校验
          isValidEmail = window.validator.isEmail(value);
        } else {
          const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
          isValidEmail = emailRegex.test(value);
        }
        
        // 第二步：使用 tldts 验证域名有效性（增强校验）
        if (isValidEmail && window.tldts) {
          try {
            const domain = value.split('@')[1]; // 提取域名部分
            if (domain) {
              const parsed = window.tldts.parse(domain);
              // 严格检查：
              // 1. domain 和 publicSuffix 必须都存在
              // 2. isIcann 或 isPrivate 必须为 true（确保是有效的 TLD）
              //    - isIcann: true 表示是 ICANN 认证的公共 TLD（如 .com, .org）
              //    - isPrivate: true 表示是私有 TLD（如 .github.io）
              if (!parsed.domain || !parsed.publicSuffix || 
                  (!parsed.isIcann && !parsed.isPrivate)) {
                   isValidEmail = false;
              }
            }
          } catch (e) {
            // tldts 解析失败，保持基础校验结果
            console.warn('tldts parsing failed:', e);
          }
        }
        
        if (!isValidEmail) {
          isValid = false;
          errorMessage = getTextInputMessage('emailInvalid', 'Email format incorrect, please try again.');
        }
      }
    }
    
    // 手机号验证
    if (fieldType === 'tel') {
      const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
      if (!phoneRegex.test(value.replace(/[\s\-\(\)]/g, ''))) {
        isValid = false;
        errorMessage = getTextInputMessage('invalidPhoneNumber', 'Please enter a valid phone number');
      }
    }
    
    // 密码验证
    if (fieldType === 'password') {
      const lengthValid = value.length >= 8;
      const alphanumericValid = /^(?=.*[A-Za-z])(?=.*\d)/.test(value);
      const noSpaceValid = !/\s/.test(value);
      // 只允许英文字符、数字、特殊字符（除空格）
      const onlyValidChars = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]+$/.test(value);
      
      if (!lengthValid || !alphanumericValid || !noSpaceValid || !onlyValidChars) {
        isValid = false;
        errorMessage = getTextInputMessage('passwordRequirementsNotMet', 'Password does not meet requirements');
      }
    }
    
    // 应用验证结果
    if (!isValid) {
      setInputError(field, errorMessage);
    } else {
      clearInputError(field);
    }
  } else {
    // 如果没有值，清除错误状态
    clearInputError(field);
  }
  
  // 更新动态图标
  if (showDynamicIcons) {
    const currentHasError = field.classList.contains('component-text-input__field--error');
    updateDynamicIcons(clearBtn, errorIcon, hasValue, currentHasError, false);
  }
}

/**
 * 清除输入框内容
 */
function clearInput(field, label, clearBtn, errorIcon, showDynamicIcons) {
  // 清除输入框值
  field.value = '';
  if (field.dataset) {
    delete field.dataset.errorPriorityActive;
  }
  
  // 移除错误状态
  field.classList.remove('component-text-input__field--error');
  
  // 更新状态
  updateInputState(field, label, clearBtn, errorIcon, showDynamicIcons);
  
  // 聚焦到输入框
  field.focus();
  
  // 触发自定义事件
  const clearEvent = new CustomEvent('input:clear', {
    detail: { field: field }
  });
  field.dispatchEvent(clearEvent);
}

/**
 * 设置错误状态
 */
function setInputError(field, errorMessage) {
  // 避免移动端键盘触发的 resize 立刻清掉错误态：设置短暂的跳过窗口
  window.__textInputSkipResizeUntil = Date.now() + 600;
  if (!field) return;
  const localizedErrorMessage = window.localizeFrontendText ? window.localizeFrontendText(errorMessage) : errorMessage;
  
  // 移除所有可能的错误状态类，避免冲突
  field.classList.remove('component-text-input__field--error');
  field.classList.remove('component-text-input--invalid');
  field.classList.remove('component-text-input--valid');
  
  // 添加错误类（只使用一种）
  field.classList.add('component-text-input__field--error');
  if (allowsErrorOnFocus(field)) {
    field.dataset.errorPriorityActive = 'true';
  }
  
  // 设置 aria-invalid 属性
  field.setAttribute('aria-invalid', 'true');
  
  // 查找错误信息元素（使用已存在的，不创建新的）
  const errorElement = field.closest('.component-text-input').querySelector('.component-text-input__error');
  
  if (errorElement) {
    // 检查是否已经有相同的错误信息
    const currentText = errorElement.textContent.trim();
    if (currentText !== localizedErrorMessage) {
      if (window.setInputErrorMessage) {
        window.setInputErrorMessage(errorElement, localizedErrorMessage);
      } else {
        errorElement.textContent = localizedErrorMessage;
      }
    } else if (window.syncInputErrorLineState) {
      window.syncInputErrorLineState(errorElement);
    }
    errorElement.style.display = 'flex';
  }
  
  // 更新动态图标
  const input = field.closest('.component-text-input');
  if (input) {
    input.classList.add('component-text-input--has-visible-error');
    if (window.syncFormInputErrorState) {
      window.syncFormInputErrorState(input);
    }
  }
  const clearBtn = input.querySelector('.component-text-input__clear-btn');
  const errorIcon = input.querySelector('.component-text-input__error-icon');
  const showDynamicIcons = input.hasAttribute('data-show-dynamic-icons');
  
  if (showDynamicIcons) {
    updateDynamicIcons(
      clearBtn,
      errorIcon,
      field.value.trim().length > 0,
      true,
      field === document.activeElement,
      isPriorityErrorActive(field)
    );
  }
}

/**
 * 清除错误状态
 */
function clearInputError(field) {
  if (!field) return;
  
  // 移除所有错误状态类
  field.classList.remove('component-text-input__field--error');
  field.classList.remove('component-text-input--invalid');
  field.classList.remove('component-text-input--valid');
  
  // 移除 aria-invalid 属性
  field.removeAttribute('aria-invalid');
  if (field.dataset) {
    delete field.dataset.errorPriorityActive;
  }
  
  // 隐藏错误信息
  const errorElement = field.closest('.component-text-input').querySelector('.component-text-input__error');
  if (errorElement) {
    if (window.clearInputErrorMessage) {
      window.clearInputErrorMessage(errorElement);
    }
    errorElement.style.display = 'none';
  }
  
  // 更新动态图标
  const input = field.closest('.component-text-input');
  if (input) {
    input.classList.remove('component-text-input--has-visible-error');
    if (window.syncFormInputErrorState) {
      window.syncFormInputErrorState(input);
    }
  }
  const clearBtn = input.querySelector('.component-text-input__clear-btn');
  const errorIcon = input.querySelector('.component-text-input__error-icon');
  const showDynamicIcons = input.hasAttribute('data-show-dynamic-icons');
  
  if (showDynamicIcons) {
    updateDynamicIcons(
      clearBtn,
      errorIcon,
      field.value.trim().length > 0,
      false,
      field === document.activeElement,
      false
    );
  }
}

/**
 * 设置校验状态
 */
function setValidationState(field, isValid, message = '') {
  if (!field) return;
  
  const input = field.closest('.component-text-input');
  if (!input) return;
  
  // 移除之前的校验状态
  input.classList.remove('component-text-input--validating');
  input.classList.remove('component-text-input--valid');
  input.classList.remove('component-text-input--invalid');
  
  // 移除字段级别的错误状态，避免冲突
  field.classList.remove('component-text-input__field--error');
  
  if (isValid === true) {
    // 符合的项目使用primary色
    input.classList.add('component-text-input--validating');
    input.classList.add('component-text-input--valid');
    // 移除错误状态
    field.classList.remove('component-text-input__field--error');
  } else if (isValid === false) {
    // 不符合的项目使用error色
    input.classList.add('component-text-input--validating');
    input.classList.add('component-text-input--invalid');
    // 添加错误状态
    field.classList.add('component-text-input__field--error');
  }

  input.classList.toggle('component-text-input--has-visible-error', isValid === false && !!message);
  if (window.syncFormInputErrorState) {
    window.syncFormInputErrorState(input);
  }
  
  // 更新错误信息
  const errorElement = input.querySelector('.component-text-input__error');
  if (errorElement) {
    if (message && !isValid) {
      const localizedMessage = window.localizeFrontendText ? window.localizeFrontendText(message) : message;
      if (window.setInputErrorMessage) {
        window.setInputErrorMessage(errorElement, localizedMessage);
      } else {
        errorElement.textContent = localizedMessage;
      }
      errorElement.style.display = 'flex';
    } else {
      if (window.clearInputErrorMessage) {
        window.clearInputErrorMessage(errorElement);
      }
      errorElement.style.display = 'none';
    }
  }
  
  // 更新label状态和动态图标
  const label = input.querySelector('.component-text-input__label');
  const clearBtn = input.querySelector('.component-text-input__clear-btn');
  const errorIcon = input.querySelector('.component-text-input__error-icon');
  const showDynamicIcons = input.hasAttribute('data-show-dynamic-icons');
  
  if (label) {
    updateInputState(field, label, clearBtn, errorIcon, showDynamicIcons);
  }
}

/**
 * 清除校验状态
 */
function clearValidationState(field) {
  if (!field) return;
  
  const input = field.closest('.component-text-input');
  if (!input) return;
  
  // 移除所有校验状态
  input.classList.remove('component-text-input--validating');
  input.classList.remove('component-text-input--valid');
  input.classList.remove('component-text-input--invalid');
  
  // 移除字段级别的错误状态
  field.classList.remove('component-text-input__field--error');
  
  // 隐藏错误信息
  const errorElement = input.querySelector('.component-text-input__error');
  if (errorElement) {
    errorElement.style.display = 'none';
  }

  input.classList.remove('component-text-input--has-visible-error');
  if (window.syncFormInputErrorState) {
    window.syncFormInputErrorState(input);
  }
  
  // 更新label状态和动态图标
  const label = input.querySelector('.component-text-input__label');
  const clearBtn = input.querySelector('.component-text-input__clear-btn');
  const errorIcon = input.querySelector('.component-text-input__error-icon');
  const showDynamicIcons = input.hasAttribute('data-show-dynamic-icons');
  
  if (label) {
    updateInputState(field, label, clearBtn, errorIcon, showDynamicIcons);
  }
}

// 导出函数供外部使用
window.TextInputComponent = {
  init: initTextInputs,
  setError: setInputError,
  clearError: clearInputError,
  clearInput: clearInput,
  setValidationState: setValidationState,
  clearValidationState: clearValidationState,
  updateInputState: updateInputState,
  updatePasswordToggleVisibility: updatePasswordToggleVisibility,
  updateDynamicIcons: updateDynamicIcons,
  detectXSS: detectXSS,
  detectSQLInjection: detectSQLInjection,
  sanitizeInput: sanitizeInput
};

// 页面加载时自动初始化
document.addEventListener('DOMContentLoaded', function() {
  initTextInputs();
});

// 立即执行一次，以防DOMContentLoaded已经触发
if (document.readyState === 'loading') {
  // Document still loading, waiting for DOMContentLoaded
} else {
  initTextInputs();
}

// 窗口大小改变时重新初始化（处理设备切换）
window.addEventListener('resize', function() {
  // 如果刚设置过错误态，跳过一次重初始化，避免真机上闪烁
  if (window.__textInputSkipResizeUntil && Date.now() < window.__textInputSkipResizeUntil) {
    return;
  }
  // 防抖处理
  clearTimeout(window.textInputResizeTimeout);
  window.textInputResizeTimeout = setTimeout(() => {
    initTextInputs();
  }, 120);
}); 
